import React from "react";
import {LogoMastercardIcon} from "../../../../../../../assets/svg/logo-mastercard.icon";
import {CardNetworkModel} from "./card-network.model";
import {CardNetworksEnum} from "../../payment-method-codes.enum";
import {ICardNetworkIconOptions} from "./card-network.view-model.interface";

export class MastercardCardNetworkModel extends CardNetworkModel {
    constructor() {
        super(CardNetworksEnum.MasterCard);
    }

    get name(): string {
        return "Mastercard";
    }

    renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null {
        return (<LogoMastercardIcon {...options}/>);
    }
}